export const groundworksFoundations = [
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "1.0",
    Description: "FOUNDATIONS & FLOORS",
    Qty: "1",
    Unit: "item",
    Rate: "1267856.17",
    Amount: "£1,267,856.17",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "1.1",
    Description: "Trenchfill B&B Floor Foundations",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Standard 1175mm from FFL (500mm concrete; 675mm masonry).  ",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Included",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "Allowance for additional depths to the formation levels shown on the Foundation Schedule Drawing P10298-01 Rev B.",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Included",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Mesh to footings spanning varable strata - no details",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Excluded",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Claymaster heave protection",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Included",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "1.2",
    Description: "Piled Ringbeam Foundations",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "Standard 1225mm from FFL (50mm blinding; 500mm reinforced ground beam; 675mm masonry).",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Included",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Pile matt - assumed 300mm thick recycled 6F2",
    Qty: "5495",
    Unit: "m²",
    Rate: "17.03",
    Amount: "£93,579.85",
  },
  {
    Item: "",
    Description: "Allowance for 50% reuse of stone",
    Qty: "824",
    Unit: "m²",
    Rate: "-18.09",
    Amount: "-£14,906.16",
  },
  {
    Item: "",
    Description: "CBR Testng",
    Qty: "1",
    Unit: "item",
    Rate: "2051.46",
    Amount: "£2,051.46",
  },
  {
    Item: "",
    Description: "Increased Piling Matt Plots 173 - 202",
    Qty: "2987",
    Unit: "m2",
    Rate: "6.29",
    Amount: "£18,800.32",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Setting out for piling contractor",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Included",
  },
  {
    Item: "",
    Description: "Attendance upon piling contractor",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Included",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Pile crop",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Included",
  },
  {
    Item: "",
    Description: "Filling steel piles",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Excluded",
  },
  {
    Item: "",
    Description: "Removal of CFA arisings",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Excluded",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Rebar as per the provided Rebar Schedules",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Included",
  },
  {
    Item: "",
    Description: "Cordek cellcore HX-B 150mm",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Included",
  },
  {
    Item: "",
    Description: "Claymaster heave protection",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Included",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "1.3",
    Description: "Generally",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "Facings to foundations to be supplied free-issue by Morris Homes",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "By Morris",
  },
  {
    Item: "",
    Description: "Exposed brickwork",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Included",
  },
  {
    Item: "",
    Description: "Tanking",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Included",
  },
  {
    Item: "",
    Description: "EO Coloured mortar",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Included",
  },
  {
    Item: "",
    Description:
      "Due to min order volumes, min 6 plots required to be available.",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "1.4",
    Description: "Beam & Block Floors",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "Longley concrete beam & polystyrene infill-panel floor to acehive a 0.15 U-value; 1200g & 500g membrane; minimum 250mm void; 75mm concrete screed with Durus macro-fibres.",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Included",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "1.5",
    Description:
      "Suspended Insitu Concrete Paving Floor- Provisional, no details",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mm thick reinforced concrete paving (A393 bottom mesh); 1200g membrane; 150mm thick Kingspan TF70 insulation; 50mm sand blinding",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Excluded",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Allowance for top mesh - none shown",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Excluded",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "2.0",
    Description: "BIN / CYCLES STORE TO APARTMENTS - PROV ISIONAL SUM",
    Qty: "1",
    Unit: "item",
    Rate: "3500.00",
    Amount: "£3,500.00",
  },
  {
    Item: "",
    Description:
      "Assumed 150mm thick insitu paving reinforced with 1 layer of A393 mesh",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Carried forward to summary",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "£1,370,881.64",
  },
];
